// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3XF0q","legacyBtn":"MutateMid_legacyBtn__IqPbR"};